const emptyPromise = () => Promise.resolve({});
export const getIsSomeMenuVisbleSelector = emptyPromise;
export const getMenuSettingsAsync = emptyPromise;
export const getPrivilegeAsync = emptyPromise;
export const showNoviceTaskCloseTip = emptyPromise;
export const getVersionAsync = emptyPromise;
export const checkMasterInfo = () => {
    return {
        isMaster: false,
    };
};
